var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.211,
    height: 16.105,
    viewBox: "0 0 11.211 16.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20268",
    "data-name": "Path 20268",
    d: "M16.176,18.905H8.835A1.835,1.835,0,0,1,7,17.07V4.835A1.835,1.835,0,0,1,8.835,3h7.341a1.835,1.835,0,0,1,1.835,1.835V17.07A1.835,1.835,0,0,1,16.176,18.905ZM8.835,4.223a.612.612,0,0,0-.612.612V17.07a.612.612,0,0,0,.612.612h7.341a.612.612,0,0,0,.612-.612V4.835a.612.612,0,0,0-.612-.612Z",
    transform: "translate(-7 -3)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20269",
    "data-name": "Path 20269",
    d: "M15.67,5.447H13.223A1.223,1.223,0,0,1,12,4.223V3.612A.612.612,0,0,1,12.612,3h3.67a.612.612,0,0,1,.612.612v.612A1.223,1.223,0,0,1,15.67,5.447ZM13.223,4.223Z",
    transform: "translate(-8.941 -3)",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNo);
export default __webpack_public_path__ + "static/media/mobile_no.44bc7a10ea6d4c71c1103bc8402c9db8.svg";
export { ForwardRef as ReactComponent };